import axios from "axios";
import { apiURL } from "@/config";

export function cartToken() {
  return localStorage.getItem("cartToken");
}

export function setCartToken(token) {
  return localStorage.setItem("cartToken", token);
}

export async function createCart() {
  return await axios.post(apiURL + "carts", {
    responseType: "json",
  });
}

export async function dropCart() {
  const token = cartToken();
  return await axios.delete(apiURL + "carts/" + token, {
    responseType: "json",
  });
}

export async function fetchCart() {
  const token = cartToken();
  return await axios.get(apiURL + "carts/" + token, {
    responseType: "json",
  });
}

export async function addToCart(product) {
  console.log('==========');
  console.log(product);
  const token = cartToken();
  return await axios.post(`${apiURL}carts/${token}/items`, product, {
    responseType: "json",
  });
}

export async function editCart(data) {
  const token = cartToken();
  return await axios.put(
    `${apiURL}carts/${token}/items/${data.id}`,
    data.body,
    {
      responseType: "json",
    }
  );
}

export async function getCartItem(id) {
  const token = cartToken();
  return await axios.get(`${apiURL}carts/${token}/items/${id}`, {
    responseType: "json",
  });
}

export async function removeFromCart(productId) {
  const token = cartToken();
  return await axios.delete(`${apiURL}carts/${token}/items/${productId}`, {
    responseType: "json",
  });
}

export async function getFilesStatus(data) {
  const token = cartToken();
  let url = `${apiURL}carts/${token}/file/${data.productCode}/config/${data.configCode}/status`;
  if (data.orderItemId) {
    url += data.orderItemId;
  }

  return await axios.get(url, {
    responseType: "json",
  });
}
